export const DASHBOARD_PAGE_NAME = "Dashboard_Manager";
export const DASHBOARD_TABLE_NAME = "All Audits";